import { getAttributionHost } from "@attribution/host";
import { readAttributionContext, writeAttributionContext } from "@attribution/storage";

/**
 * Stamps the funnel `funnelId` onto `lastTouch.funnelId` of the persisted
 * attribution context. Call once after the funnel resolves so the handoff URL
 * and downstream CAPI events carry the funnel identifier.
 *
 * When `lastTouch` does not yet exist (the user arrived without a recognized
 * click id, UTM, or platform detail — e.g. affiliate traffic with only
 * `?ref=`), a minimal `lastTouch` is synthesized so that the funnel
 * identifier is still carried through the handoff and into downstream CAPI
 * events.
 *
 * No-op when no attribution context has been captured yet.
 */
export const stampFunnelId = (funnelId: string): void => {
  const ctx = readAttributionContext();
  if (ctx === undefined) return;

  const { lastTouch } = ctx;

  if (lastTouch === undefined) {
    writeAttributionContext({
      ...ctx,
      lastTouch: {
        capturedAt: getAttributionHost().now(),
        network: "unknown",
        clickIds: {},
        funnelId,
      },
    });
    return;
  }

  if (lastTouch.funnelId === funnelId) return;

  writeAttributionContext({
    ...ctx,
    lastTouch: { ...lastTouch, funnelId },
  });
};
